import React from 'react'
import styled from 'styled-components'
import { Col, Container } from '../components'
import { useTranslation } from 'react-i18next'

const Outer = styled.div`
  text-align: center;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px;
  }
`

const BoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`

const Text = styled.p`
  font-weight: 300;
  font-size: 25px;
  margin: 15px 50px;
  color: #363535;

  @media (max-width: 768px) {
    font-size: 16px;
    margin: 10px 20px;
  }
`

const Title = styled.p`
  font-weight: 400;
  font-size: 40px;
  color: #b19961;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`

const Summary = () => {
  const { t } = useTranslation()
  return (
    <Container id='summary'>
      <BoxWrapper>
        <Col>
          <Outer>
            <Title>{t('home.summaryTitle')}</Title>
            <Text>{t('home.summary')}</Text>
          </Outer>
        </Col>
      </BoxWrapper>
    </Container>
  )
}

export default Summary
